<template>
  <div :class="['table-layout', fullWidth ? 'table-layout-full-width' : null, borderCollapse ? 'table-layout-collapse' : null, fullHeight ? 'table-layout-full-height' : null, equalCells ? 'table-layout-fixed' : null, `table-layout-v-align-${yAlign}`, `table-layout-x-align-${xAlign}`]">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TableLayout',
  props: {
    /**
     * Expand to 100% of the viewport height
     */
    fullHeight: {
      type: Boolean,
      required: false
    },
    /**
     * Force 100% with in certain cases
     */
    fullWidth: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Apply CSS table-layout: fixed to distribute cells evenly
     */
    equalCells: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Apply CSS vertical-align ('top'|'middle'|'bottom'|'baseline')
     */
    yAlign: {
      type: String,
      required: false,
      default: 'top'
    },
    /**
     * Apply CSS text-align ('left'|'center'|'right')
     */
    xAlign: {
      type: String,
      required: false,
      default: 'left'
    },
    /**
     * Apply CSS border-collapse ('collapse'|'separate')
     */
    borderCollapse: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>
<style>
.table-layout
{
  display: table;
  width: 100%;
}

.table-layout-full-width
{
  width: 100% !important;
}

.table-layout-collapse
{
  border-collapse: collapse;
}

.table-layout > *
{
  display: table-row;
}

.table-layout > * > *
{
  display: table-cell;
}

.table-layout.table-layout-fixed
{
  table-layout: fixed;
}

.table-layout-full-height
{
  height: 100vh;
}

.table-layout-cell-x-align-left,
.table-layout-x-align-left > * > *
{
  text-align: left;
}

.table-layout-cell-x-align-center,
.table-layout-x-align-center > * > *
{
  text-align: center;
}

.table-layout-cell-x-align-right,
.table-layout-x-align-right > * > *
{
  text-align: right;
}

.table-layout-cell-v-align-top,
.table-layout-v-align-top > * > *
{
  vertical-align: top;
}

.table-layout-cell-v-align-middle,
.table-layout-v-align-middle > * > *
{
  vertical-align: middle;
}

.table-layout-cell-v-align-bottom,
.table-layout-v-align-bottom > * > *
{
  vertical-align: bottom;
}

.table-layout-cell-v-align-baseline,
.table-layout-v-align-baseline > * > *
{
  vertical-align: baseline;
}
</style>



// WEBPACK FOOTER //
// src/components/table-layout/table-layout.vue